import * as React from "react";

const styles = require('../TableFromToHeader/TableFromToHeader.pcss');

interface LProps{
    title?: string;
    key?: number;
}

export class TableHeaderDataCell extends React.Component<LProps, {}>{
    constructor(){
        super();
    }

    render(){
        return(
            <th className={styles.tHeadAsOfDate} rowSpan={2}>{this.props.title}</th>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/TableHeaderDataCell/TableHeaderDataCell.tsx